import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaArrowLeft, FaChevronRight } from 'react-icons/fa';

import Tappable from 'react-tappable/lib/Tappable';

import { fetchClaims, getAllRelatives } from '../../services';
import { FadeInTransition } from '../../components/transitions/transitions';
import ConsultationUser from '../../components/consultations/ConsultationUser';
import Header from '../../components/common/Header';
import LoadingComponent from '../../components/common/LoadingComponent';
import ClaimsStatusCard from '../../components/claims/NewClaimsStatusCard';
import { Text } from '../../components/common/Text';
import RelativeSelect from '../../components/policy/RelativeSelect';
import { logEvent } from '../../utils/logEvent';
import HospitalizationModal from '../../containers/common/HospitalizationModal';
import Modal from '../../containers/common/Modal';
import NoClaimsImage from '../../images/policy/NoClaimsFound.svg';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: #ffffff;
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  z-index: 999;
  justify-content: space-between;
  flex-direction: row;
  align-self: stretch;
  align-items: center;
  border-bottom: 1px solid #f0f3f6;
`;

const BackContainer = styled(Tappable)`
  margin-right: 0.5rem;
  padding: 0.5rem;
  display: flex;
  width: 44px;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const StyledArrow = styled(FaArrowLeft)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const HeaderText = styled(Text)`
  margin-right: 0.625rem;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-self: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 16px;
  background: #f4f4f7;
`;

const HospitalizationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  height: 100svh;
  width: 100vw;
`;

class ClaimsStart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      verticals: [],
      showVerticalsLeftScroll: false,
      showVerticalsRightScroll: true,
      ongoingClaims: [],
      completedClaims: [],
      cards: [],
      relatives: [],
      selectedRelative: null,
      showRelativeModal: false,
      showHospitalizationModal: false,
      showCashlessClaimButton: true,
      showReimbusementClaimButton: true,
      showPendingHospilationBlocker: false,
      selectedOption: null,
    };
    this.verticalScrollContainerRef = React.createRef();
  }

  componentDidMount() {
    this.getAllRelatives();
    this.getClaims('all');
    //this.setState({selectedOption: 'all'});
    logEvent('Claims Home Screen');
  }
  // setSelectedOption(option) {
  //   this.setState({ selectedOption: option });
  // }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.location.hash === '#profile' &&
      this.props.location.hash !== '#profile'
    ) {
      this.closeProfile();
      return;
    }

    if (
      prevState.selectedRelative &&
      !this.state.selectedRelative &&
      this.state.selectedRelative !== prevState.selectedRelative
    ) {
      this.getClaims('all');
    }
    // if (
    //   this.state.selectedRelative &&
    //   this.state.selectedRelative !== prevState.selectedRelative &&
    //   !this.state.loading
    // ) {
    //   this.getClaims();
    // }
    if (
      this.state.selectedRelative &&
      this.state.selectedRelative !== prevState.selectedRelative &&
      !this.state.loading
    ) {
      this.getClaims(this.state.selectedRelative);
    }
  }

  openOrder(order) {
    console.log(order);
    const { claimId } = order.claimInfo;
    const { history } = this.props;
    history.push('/claims/summary', {
      claimId,
      goBack: true,
    });
  }

  getAllRelatives = () => {
    const { authToken, user } = this.props;
    getAllRelatives(authToken)
      .then((res) => {
        const self = {
          age: user.userAge,
          dob: user.dateOfBirth,
          gender: user.userGender,
          id: 'self',
          name: user.userName,
          phone: user.userPhone,
          relation: user.userType,
        };
        const relatives = [...res.relatives];
        this.setState({
          relatives,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  getClaims(id = null) {
    const { authToken, location, history } = this.props;

    this.setState({
      loading: true,
    });
    if (!id) {
      id =
        this.state.selectedRelative && this.state.selectedRelative
          ? this.state.selectedRelative
          : 'all';
    }
    fetchClaims(id, authToken)
      .then((res) => {
        console.log(res);
        const cards = res.cards;
        const ongoingClaims = res.claims.filter((claim) => {
          return claim.claimInfo.status.ongoing === true;
        });
        const completedClaims = res.claims.filter((claim) => {
          return claim.claimInfo.status.ongoing === false;
        });

        this.setState(
          {
            completedClaims,
            ongoingClaims,
            cards,
          },
          () =>
            this.setState({
              loading: false,
            })
        );

        if (location && location.search) {
          console.log(location.search);
          const params = new URLSearchParams(location.search);
          console.log(params.get('requestId'));
          if (params && params.get('requestId')) {
            const requestId = params.get('requestId');
            const claimInfo = res.claims.filter((claim) => {
              return claim.claimInfo.claimId == requestId;
            });
            if (claimInfo && claimInfo.length > 0) {
              history.push('/claims/summary', {
                claimId: requestId,
                goBack: false,
              });
            } else {
              history.push('/home');
            }
          }
        }
      })
      .catch((err) => {
        console.error('Error fetching claims:', err);
        this.setState({
          loading: false,
        });
      })
      .finally(() => {});
  }

  hideModal = () => {
    this.setState({
      showRelativeModal: false,
      showHospitalizationModal: false,
    });
  };

  selectRelative = (ele) => {
    this.setState({
      selectedRelative: ele,
      showRelativeModal: false,
    });
  };

  onCardClick = (card) => {
    const { history } = this.props;
    if (card && card.cardType === 'hospitalisation') {
      this.setState({
        showCashlessClaimButton: Boolean(card.canIntimateClaimForPolicy),
        showReimbusementClaimButton: Boolean(card.canSubmitClaimForPolicy),
      });
      this.showHospitalization();
    } else {
      this.setState({
        showCashlessClaimButton: true,
        showReimbusementClaimButton: true,
      });
      if (card.fulfillmentDetailsAvailable) {
        history.push('/reimbursement/preview');
      } else {
        history.push('/reimbursement/fulfillment-details', {
          fulfillmentDetailsAvailable: card.fulfillmentDetailsAvailable,
        });
      }
    }
  };

  showHospitalization(ele) {
    this.setState({
      showHospitalizationModal: true,
      showPendingHospilationBlocker: true,
    });
  }

  handleOutsideClick = (e) => {
    if (this.node && this.node.contains(e.target)) {
      return null;
    }
    this.setState({ showPendingHospilationBlocker: false });
  };

  openGmcOrder(order) {
    console.log(order);
    const { claimId } = order.claimInfo;
    const { history } = this.props;
    history.push('/hospitalization/claim-reimbursement-status', {
      claimId,
      from: 'claims',
    });
  }

  render() {
    const {
      selectedRelative,
      cards,
      ongoingClaims,
      completedClaims,
      showRelativeModal,
      relatives,
      showHospitalizationModal,
      showPendingHospilationBlocker,
    } = this.state;
    const { history } = this.props;

    const ConsultationCard = (ele) => {
      const type = ele.cardType;
      switch (type) {
        case 'reimbursement-claim':
          return (
            <ClaimsStatusCard
              key={ele.requestId}
              orderRequest={ele}
              onTap={() => this.openOrder(ele)}
            />
          );
        case 'gmc-claim':
          return (
            <ClaimsStatusCard
              key={ele.requestId}
              orderRequest={ele}
              onTap={() => this.openGmcOrder(ele)}
            />
          );
        default:
          return '';
      }
    };
    return (
      <FadeInTransition
        in={true}
        timeout={200}
        mountOnEnter
        unmountOnExit
        appear
      >
        <OuterContainer>
          <Header
            title="My Claims"
            noBorder
            onTap={
              this.props.location?.state?.source === 'new-reimbursement'
                ? () => {
                    if (
                      this.props.location?.state?.source === 'new-reimbursement'
                    ) {
                      history?.replace('/new-reimbursement/preview');
                    }
                  }
                : null
            }
          >
            <ConsultationUser
              // icon={selectedRelative.relativeIcon}
              text={'Filters'}
              onTap={() => {
                this.setState({
                  showRelativeModal: true,
                });
              }}
            />
          </Header>
          {this.state.loading ? (
            <LoadingComponent />
          ) : (
            <OuterContainer>
              {!!(ongoingClaims.length || completedClaims.length) && (
                <BodyContainer>
                  {cards.map((card, idx) => {
                    return (
                      <div
                        className="blue-box flex-row-center-end mb-12"
                        key={idx}
                        onClick={() => {
                          this.onCardClick(card);
                        }}
                      >
                        <div>
                          <span className="txt-white-600-13">{card.label}</span>
                          <br />
                          <span className="txt-500-white-12">
                            {card.description}
                          </span>
                        </div>
                        <div className="h-100">
                          <span
                            className="vertical-line"
                            style={{ borderColor: '#ffffff' }}
                          />
                          <FaChevronRight />
                        </div>
                      </div>
                    );
                  })}

                  {ongoingClaims.length > 0 && (
                    <div>
                      <div className="text-title-s font-semibold p-64px text-txtlight mb-16px mt-8">
                        Ongoing
                      </div>
                      {ongoingClaims.map(ConsultationCard)}
                    </div>
                  )}

                  {completedClaims.length > 0 && (
                    <div>
                      <div className="text-title-s font-semibold p-64px text-txtlight mb-16 mt-8">
                        Completed
                      </div>
                      {completedClaims.map(ConsultationCard)}
                    </div>
                  )}
                  {showRelativeModal && (
                    <RelativeSelect
                      relatives={relatives}
                      hideModal={this.hideModal}
                      selectedRelative={selectedRelative}
                      selectRelative={this.selectRelative}
                    />
                  )}
                </BodyContainer>
              )}
              {ongoingClaims.length === 0 &&
                completedClaims.length === 0 &&
                !this.state.loading && (
                  <BodyContainer>
                    {cards.map((card, idx) => {
                      return (
                        <div
                          className="blue-box flex-row-center-end mb-12"
                          key={idx}
                          onClick={() => {
                            this.onCardClick(card);
                          }}
                          style={{ paddingLeft: '1rem' }}
                        >
                          <div>
                            <span className="txt-white-600-13">
                              {card.label}
                            </span>
                            <br />
                            <span className="txt-500-white-12">
                              {card.description}
                            </span>
                          </div>
                          <div className="h-100">
                            <span
                              className="vertical-line"
                              style={{ borderColor: '#ffffff' }}
                            />
                            <FaChevronRight />
                          </div>
                        </div>
                      );
                    })}
                    <div className="flex  flex-col items-center w-full px-20px text-center">
                      <div className="mt-24">
                        <img
                          src={NoClaimsImage}
                          height="200px"
                          width="200px"
                        ></img>
                      </div>
                      <p className="text-body-s font-semibold mt-14">
                        You don't have an ongoing claim request
                      </p>
                      {/* <button
                    onClick={() =>
                      this.props.history.push('/reimbursement/preview')
                    }
                    className="flex w-full py-14px bg-primary justify-center mt-24 rounded-12 text-body-l text-txtlight font-semibold"
                  >
                    Claim Now
                  </button> */}
                    </div>
                    {showRelativeModal && (
                      <RelativeSelect
                        relatives={relatives}
                        hideModal={this.hideModal}
                        selectedRelative={selectedRelative}
                        selectRelative={this.selectRelative}
                      />
                    )}
                  </BodyContainer>
                )}
              {showHospitalizationModal && (
                <Modal>
                  <HospitalizationModalContainer
                    onClick={this.handleOutsideClick}
                  >
                    <FadeInTransition
                      in={showPendingHospilationBlocker}
                      mountOnEnter
                      unmountOnExit
                      onExited={this.hideModal}
                      appear
                    >
                      <div
                        ref={(node) => (this.node = node)}
                        className="bg-textbox flex flex-col items-center justify-center rounded-12"
                        style={{ width: '90%', maxWidth: '400px' }}
                      >
                        <HospitalizationModal
                          title={'Hospitalization'}
                          method1={'Claim Reimbursement'}
                          tag1={
                            'Get reimbursed for your previous hospitalisation'
                          }
                          method2={'Cashless Initmation Request'}
                          tag2={'Go cashless for your treatment'}
                          history={this.props.history}
                          showCashlessClaimButton={
                            this.state.showCashlessClaimButton
                          }
                          showReimbusementClaimButton={
                            this.state.showReimbusementClaimButton
                          }
                        />
                      </div>
                    </FadeInTransition>
                  </HospitalizationModalContainer>
                </Modal>
              )}
            </OuterContainer>
          )}
        </OuterContainer>
      </FadeInTransition>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  user: state.user,
});

export default connect(mapStateToProps)(ClaimsStart);
